"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAssetRemoveDataRequest extends new_item_1.default {
    constructor(newAssetRemoveDataRequest) {
        super();
        this.assetId = newAssetRemoveDataRequest.assetId;
        this.start = newAssetRemoveDataRequest.start;
        this.end = newAssetRemoveDataRequest.end;
        this.status = newAssetRemoveDataRequest.status;
    }
}
exports.default = NewAssetRemoveDataRequest;
//# sourceMappingURL=new-assetRemoveDataRequest.js.map